import contractClaimTranslations from "./contractClaimTranslations";

const otherContractTranslations = {
  label: "Sonstiger Vertrag",
  endOfContractDate: {
    label: "Datum Vertragsende",
  },
  ...contractClaimTranslations,
};

export default otherContractTranslations;
